import type * as React from 'react';
import cx from 'classnames';
import { useTranslation } from 'next-i18next';
import { Heading } from '@dx-ui/global-ui-prism';

type IPreviewHeadline = {
  title: string;
  titleType?: 'heading' | 'subheading';
  showTitle?: boolean;
  dates?: {
    arrivalDateFmt: string;
    departureDateFmt: string;
    cutOffDateFmt: string;
  };
};

const PreviewHeadline: React.FC<React.PropsWithChildren<IPreviewHeadline>> = ({
  title,
  showTitle = true,
  titleType = 'heading',
  dates,
}) => {
  const { t } = useTranslation();
  const isSubHeading = titleType === 'subheading';
  return (
    <div
      className={cx('my-5 md:mx-0', {
        'mx-0': isSubHeading,
      })}
    >
      <div
        className={cx({
          'py-2 px-0': !isSubHeading,
        })}
      >
        {showTitle && (
          <div>
            {titleType === 'subheading' ? (
              <Heading level={2} size="lg" className="mb-0 flex">
                {title}
              </Heading>
            ) : (
              <Heading level={1} size="xl" className="mb-0 flex">
                {title}
              </Heading>
            )}
          </div>
        )}
        {dates && (
          <div className="mb-2">
            <div className="mx-0">
              <Heading level={3} size="sm" className="mb-0 inline-block font-bold">
                <span className="me-2 inline-block">{t('textContent.eventDates')}</span>
                <span className="me-2 inline-block font-normal">{`${dates.arrivalDateFmt} - ${dates.departureDateFmt}`}</span>
              </Heading>
            </div>
            {dates.cutOffDateFmt && (
              <div>
                <Heading level={3} size="xs" className="mb-0 inline-block font-bold">
                  <span className="me-2 inline-block">{t('textContent.bookBefore')}</span>
                  <span className="me-2 inline-block font-normal">{dates.cutOffDateFmt}</span>
                </Heading>
              </div>
            )}
          </div>
        )}
      </div>
      <div
        className="relative h-[3px] after:absolute after:start-0 after:top-0 after:h-[3px] after:w-full after:max-w-full after:bg-surface-interactive after:content-['']"
        data-testid="progressStatusBar"
      />
    </div>
  );
};

export default PreviewHeadline;
